﻿import { HapticFeedbackStyle, HapticsApi } from './HapticsApi'
import { RundotGameAPI } from '../rundot-game-api/types'

export class MockHapticsApi implements HapticsApi {
  private readonly rundotGameApi: RundotGameAPI

  constructor(rundotGameApi: RundotGameAPI) {
    this.rundotGameApi = rundotGameApi
  }

  async triggerHapticAsync(style: HapticFeedbackStyle): Promise<void> {
    const rundotGameApi = this.rundotGameApi
    // Check if device supports haptics
    if (!rundotGameApi._mock.device.supportsHaptics) {
      return
    }
  }
}
